var dealers = {
    data: {
        records:[],
        countries:[],
        states:[],
        dealers:[]
    },
    init: function() {
        
        fetch('https://apps.sltwtr.com/sheets/?sheet=19Z48iVNJpXejvuUKJ2pN4yfSWhdqyIGGQK65ntMhcBc')
            .then(response => response.json())
            .then(data => {
                dealers.data.records = data
                dealers.scrub()
                dealers.map()
                Neptune.liquid.load('dealers')
                dealers.country('us')
            });
    },
    scrub: function() {
        dealers.data.countries = []
        dealers.data.records.forEach(r=>{
            if (dealers.data.countries.map(r=>r.code).indexOf(r.country_code)==-1){
                dealers.data.countries.push({code:r.country_code,name:r.country})
            }
        })
        dealers.data.countries.sort((a, b) => (a.name > b.name) ? 1 : -1)
    },
    load: function(what) {
        // Neptune.liquid.load()
    },
    map: function() {
        $('#vmap').vectorMap({
            map: 'world_en',
            backgroundColor: null,
            color: '#ffffff',
            hoverOpacity: 0.7,
            selectedColor: '#666666',
            enableZoom: true,
            showTooltip: true,
            values: distinct_map_data,
            scaleColors: ['#C8EEFF', '#006491'],
            normalizeFunction: 'polynomial',
            showTooltip: true,
            onRegionClick: function(element, code, region)
            {
                dealers.country(code)
            }
        });
    },
    table: function() {
        if(!dealers.dataTable){
            dealers.dataTable = $('#dealersTable').DataTable({
                data: dealers.data.dealers.map(d=>Object.values(d)),
                columns: Object.keys(dealers.data.dealers[0]).map(c=>{return {title:c} }),
                columnDefs: [{ "visible": false,  "targets": [ 0,1,6,10,13 ] }]
            });
        } else {
            dealers.dataTable.clear()
            dealers.dataTable.rows.add(dealers.data.dealers.map(d=>Object.values(d)))
            dealers.dataTable.draw()
        }
    },
    country: function(code) {
        dealers.data.country = code;
        delete dealers.data.state;
        delete dealers.data.city;
        dealers.data.dealers = dealers.data.records.filter(r=>r.country_code.toLowerCase() == code.toLowerCase())
        // dealers.data.states = _n.unique(dealers.data.dealers,'state').filter(s=>!!s).sort()
        dealers.data.states = _n.unique(dealers.data.dealers.map(d=>d.state)).sort()
        dealers.data.cities = _n.unique(dealers.data.dealers.map(d=>d.city)).sort()
        Neptune.liquid.load('dealers')
        dealers.table()
    },
    state: function(country, state) {
        dealers.data.state = state;
        delete dealers.data.city;
        dealers.data.dealers = dealers.data.records.filter(r=>r.state.toLowerCase() == state.toLowerCase() && r.country_code.toLowerCase() == country.toLowerCase())
        dealers.data.cities = _n.unique(dealers.data.dealers.map(d=>d.city)).sort()
        Neptune.liquid.load('dealers')
        dealers.table()  
    },
    city: function(country, state, city) {
        dealers.data.city = city;
        dealers.data.dealers = dealers.data.records.filter(r=>r.state.toLowerCase() == state.toLowerCase() && r.country_code.toLowerCase() == country.toLowerCase() && r.city.toLowerCase() == city.toLowerCase())
        Neptune.liquid.load('dealers')
        dealers.table()  
    },
    distance: function(distance,zip) {
        dealers.data.zip = zip
        if(!zip || zip.length < 5){
            _n.qs('input#zip').focus();
        } else if(distance == 0){
            _n.qs('select#distance').focus();
        } else {
            fetch('https://www.zipcodeapi.com/rest/'+jszipcodeapi_key+'/radius.json/'+zip+'/'+distance+'/miles')
            .then(response => response.json())
            .then(data => {
                const zips = data.zip_codes.map(i=>i.zip_code)
                console.log(zips)
                dealers.data.dealers = dealers.data.records.filter(r=>zips.includes(r.zip))
                Neptune.liquid.load('dealers')
                dealers.table()  
            });
        }
    }
}
window.addEventListener('DOMContentLoaded', dealers.init)





var dealersTable = 0;
var selectedCountryCode = 'us';
var selectedSubCountryCode = '';
var selectedStateCode = '';
var selectedSubRegionCode = '';
var selectedCityCode = '';
var distinct_map_data = {};

var zipcodeapi_key="7SbGL6KlXvr00UY9UhC5FFBO44pHTdd05pGRwqcuWEuXyt6tLJyqoafteEa8Ro8X";
var jszipcodeapi_key="js-J8IkF5asCYz2BWaZPyLGANfkrWVUuDveMdysiIVVHuYjr8ihH3XiRcCi8xcDbHRY";

var records = []


$(function(){

    init_page();

    function init_page(){



        get_countries_data();
        //get_sub_countries_data();
        //get_state_data();
        //get_sub_region_data();
        //get_city_data();


         // We do this to get the proper selection on the map
        /*
        setTimeout( function(){
            $('#country_select').val('ca').trigger('change');
        }, 100 );


        setTimeout( function(){
            $('#country_select').val('us').trigger('change');
        }, 200 );
        */
    }

		function get_zip_code_data(){

				var zip = $('input#zip').val();
				var distance = $('select#distance').val();
				console.log('zip: ', zip);
				console.log('distance: ', distance);
				if(!zip || zip.length < 5){
					$('input#zip').focus();
				} else if(distance == 0){
				 $('[data-toggle="dropdown"]').dropdown('toggle');
				} else {
					
					var results = [];
					var zip_url = 'https://www.zipcodeapi.com/rest/'+jszipcodeapi_key+'/radius.json/'+zip+'/'+distance+'/miles';
					$.get(zip_url, function(data){
							load_zip_code_table_data(data.zip_codes);
					},'json');

				}
		}


    function get_countries_data(){
      $.get('/wp-content/themes/ci/lib/superadmin/index.php/dealers?columns=country_code,country', function(data){
              var records = data.dealers.records;
              var distinct = get_distinct_data( records, 1);
              // this gets a count by country for the map
              for( var i in records ){
                  var country_code = data.dealers.records[i][1];
                  var country_name = data.dealers.records[i][0];
                  if( typeof(distinct_map_data[country_code]) == "undefined"){
                      distinct_map_data[country_code] = 1;
                  }else{
                      distinct_map_data[country_code] = distinct_map_data[country_code] + 1;
                  }
              }
              load_select_data( distinct, '#country_select', 'Country' );
              sort_select( '#country_select'  );
              load_map_data();

      },'json');
    }

    function get_sub_countries_data(){
      var filterString = '';
      if( selectedCountryCode ){
          filterString += '&filter[]=country_code,eq,'+selectedCountryCode;
      }
      $.get('/wp-content/themes/ci/lib/superadmin/index.php/dealers?columns=sub_country' + filterString, function(data){
              var records = data.dealers.records;
              var distinct = get_distinct_data( records, 0);
              load_select_data( distinct, '#sub_country_select', 'Region' );
              sort_select( '#sub_country_select'  );

      },'json');

    }

    function get_state_data(){
            var filterString = '';
            if( selectedCountryCode ){
                filterString += '&filter[]=country_code,eq,'+selectedCountryCode;
            }
            if( selectedSubCountryCode ){
                filterString += '&filter[]=sub_country,eq,'+selectedSubCountryCode;
            }
            $.get('/wp-content/themes/ci/lib/superadmin/index.php/dealers?columns=state&'+ filterString, function(data){
                  var records = data.dealers.records;
                  var distinct = get_distinct_data( records, 0);
                  load_select_data( distinct, '#state_select', 'State' );

                  sort_select( '#state_select'  );

            },'json');

    }

    function get_sub_region_data(){
            var filterString = '';
            if( selectedCountryCode ){
                filterString += '&filter[]=country_code,eq,'+selectedCountryCode;
            }
            if( selectedSubCountryCode ){
                filterString += '&filter[]=sub_country,eq,'+selectedSubCountryCode;
            }
            if( selectedStateCode ){
                filterString += '&filter[]=state,eq,'+selectedStateCode;
            }
            $.get('/wp-content/themes/ci/lib/superadmin/index.php/dealers?columns=sub_region'+ filterString, function(data){
                var records = data.dealers.records;
                var distinct = get_distinct_data( records, 0);
                load_select_data( distinct, '#sub_region_select', 'Area' );
                sort_select( '#sub_region_select'  );
            },'json');

    }


    function get_city_data(){
                var filterString = '';
                if( selectedCountryCode ){
                    filterString += '&filter[]=country_code,eq,'+selectedCountryCode;
                }
                if( selectedSubCountryCode ){
                    filterString += '&filter[]=sub_country,eq,'+selectedSubCountryCode;
                }
                if( selectedStateCode ){
                    filterString += '&filter[]=state,eq,'+selectedStateCode;
                }
                if( selectedSubRegionCode ){
                    filterString += '&filter[]=sub_region,eq,'+selectedSubRegionCode;
                }
                $.get('/wp-content/themes/ci/lib/superadmin/index.php/dealers?columns=city'+ filterString, function(data){
                    var records = data.dealers.records;
                    var distinct = get_distinct_data( records, 0);
                    load_select_data( distinct, '#city_select', 'City' );
                    sort_select( '#city_select'  );
                },'json');

    }




    function load_select_data( distinct, selector, label){
        $(selector).find('option').remove();
        $( selector ).append($('<option selected="selected" value="">Select '+label+'</option>'));
        var append_count = 0;
        for(var propertyName in distinct ) {
            var record_info = distinct[propertyName];
            if( record_info.code  ){
                 $( selector ).append($("<option></option>").attr("value", record_info.code).text(record_info.name + ' (' + record_info.count + ')')); 
                 append_count++;
            }
        }
        if(! append_count || append_count == 1){
            $(selector).parent('div').addClass('hide');
        }else{
            $(selector).parent('div').removeClass('hide');
        }
    }


     function load_map_data(){
         $('#vmap').vectorMap({
            map: 'world_en',
            backgroundColor: null,
            color: '#ffffff',
            hoverOpacity: 0.7,
            selectedColor: '#666666',
            enableZoom: true,
            showTooltip: true,
            /*values: sample_data,*/
            values: distinct_map_data,
            scaleColors: ['#C8EEFF', '#006491'],
            normalizeFunction: 'polynomial',
            showTooltip: true,
            onRegionClick: function(element, code, region)
            {
                selectedCountryCode = code;
                regionClick(code, region);
            }
        });

     }


         /*
        setTimeout( function(){
            regionClick(selectedCountryCode, 'United States');
        }, 300 );
        */

				$('#distance').on('change', function (e){
					get_zip_code_data();
				});
				$('#zip').on('blur', function(e){
					get_zip_code_data();
				});

        $('#country_select').on('change', function (e){
            var $selected = $(this).find(":selected");
            var code = $selected.val();

            var region_name = $selected.text().split(' (')[0];
            regionClick( code, region_name );
        });

        $('#sub_country_select').on('change', function (e){
            var $selected = $(this).find(":selected");
            var code = $selected.val();

            // update map
            selectedStateCode = '';
            selectedSubRegionCode = '';
            selectedCityCode = '';
            selectedSubCountryCode = code;
            get_state_data();
            get_sub_region_data();
            get_city_data();
            load_new_table_data();
            
        });
        $('#state_select').on('change', function (e){
            var $selected = $(this).find(":selected");
            var code = $selected.val();

            // update map
            selectedSubRegionCode = '';
            selectedCityCode = '';
            selectedStateCode = code;
            get_sub_region_data();
            get_city_data();
            load_new_table_data();
            
        });
        $('#sub_region_select').on('change', function (e){
            var $selected = $(this).find(":selected");
            var code = $selected.val();

            // update map
            selectedCityCode = '';
            selectedSubRegionCode = code;
            get_city_data();
            load_new_table_data();
            
        });

        $('#city_select').on('change', function (e){
            var $selected = $(this).find(":selected");
            var code = $selected.val();

            // update map
            selectedCityCode = code;
            load_new_table_data();
            
        });


        function get_distinct_data( records, key_index ){
            var distinct = {};
            for( var i in records ){
                var this_record = records[i];
                var key = records[i][key_index];
                var country_name = records[i][0];
                if( typeof( distinct[key]) == "undefined"){
                    distinct[key] = {name:country_name,code:key, count: 1};
                }else{
                    distinct[key].count = distinct[key].count + 1;
                }
            }
            return distinct;
        }


        function regionClick(code, region){
            // update map
            $('#country_select').val(code);
						if( code == 'us' ){
							$('.usa-only').removeClass('hide');
						}else{
							$('.usa-only').addClass('hide');
						}
            
            $vmap = $('#vmap');
            $vmap.vectorMap('deselect', selectedCountryCode);
            $vmap.vectorMap('select', code);

            // get data
            selectedSubCountryCode = '';
            selectedStateCode = '';
            selectedSubRegionCode = '';
            selectedCityCode = '';
            selectedCountryCode = code;
            get_sub_countries_data();
            get_state_data();
            get_sub_region_data();
            get_city_data();

            $('.post-region').text( region );
            load_new_table_data();
        }

        function load_new_table_data(){
            // &filter[]=country_code,eq,'+selectedCountryCode
            var filterString = '';
            if( selectedCountryCode ){
                filterString += '&filter[]=country_code,eq,'+selectedCountryCode;
            }
            if( selectedSubCountryCode ){
                filterString += '&filter[]=sub_country,eq,'+selectedSubCountryCode;
            }
            if( selectedStateCode ){
                filterString += '&filter[]=state,eq,'+selectedStateCode;
            }
            if( selectedSubRegionCode ){
                filterString += '&filter[]=sub_region,eq,'+selectedSubRegionCode;
            }
            if( selectedCityCode ){
                filterString += '&filter[]=city,eq,'+selectedCityCode;
            }
            console.log('filterString: ', filterString);
            $.get('/wp-content/themes/ci/lib/superadmin/index.php/dealers?columns=name,address,city,state,country,website,phone,zip'+filterString , function(data){
                var headers_array = [];
                for (var i=0; i < data.dealers.columns.length; i++) {
                    var header_slug = data.dealers.columns[i];
                    headers_array[i] = {};
                    headers_array[i].title = header_slug;
                }

                if( dealersTable ){
                    dealersTable.destroy();
                }
                load_data_table( headers_array, data.dealers.records );
                
            },'json');

        }


				function load_zip_code_table_data( zip_code_objects ){
            var filterString = '';
						// USA only
						filterString += '&filter[]=country,eq,USA';
						var zip_array = [];
						for (var i=0; i < zip_code_objects.length; i++) {
							var zip_code = zip_code_objects[i].zip_code;
							zip_array.push(zip_code);
							//filterString += '&filter[]=zip,eq,'+zip_code;
						}
						var zip_string = zip_array.join(',');
						filterString += '&filter[]=zip,in,'+zip_string;
            console.log('filterString: ', filterString);
						var dealer_data_url = '/wp-content/themes/ci/lib/superadmin/index.php/dealers?columns=name,address,city,state,country,website,phone,zip'+filterString;
            $.get( dealer_data_url , function(data){
                var headers_array = [];
                for (var i=0; i < data.dealers.columns.length; i++) {
                    var header_slug = data.dealers.columns[i];
                    headers_array[i] = {};
                    headers_array[i].title = header_slug;
                }

                if( dealersTable ){
                    dealersTable.destroy();
                }
                load_data_table( headers_array, data.dealers.records );
                
            },'json');

        }

        function load_data_table( headers_array, dataSet ){
            dealersTable = $('#example').DataTable( {
                data: dataSet,
                columns: headers_array
            } );
        }



        function array_unique(arr) {
            var result = [];
            for (var i = 0; i < arr.length; i++) {
                if (result.indexOf(arr[i]) == -1) {
                    result.push(arr[i]);
                }
            }
            return result;
        }

        function sort_select( selector ){
						
            var sel = $( selector );
            var opts_list = sel.find('option');
            opts_list.sort(function(a, b) { 
							  var a_text = $(a).text();
                var retval = a_text > $(b).text() ? 1 : -1;
                if( a_text.substring(0, 6) == 'Select'){
                    retval = -1;
                }
								if( a_text.indexOf('USA (') !== -1){
                    retval = -1;
                }
                return retval;
            });
            sel.html('').append(opts_list);
            sel.val('');
        }



});



